module.exports = __webpack_public_path__ + "img/facilitate-social-sharing.f9c4f783.svg";